<template>
  <el-skeleton :loading="technicalSheetLoading" animated>
    <template slot="template">
      <div class="flex gaps auto">
        <el-skeleton-item
          variant="image"
          style="width: 240px; height: 240px;"
        />
        <span >
          <el-skeleton-item style="width:30%" /><br>
          <el-skeleton-item style="width:50%" />
        </span>
      </div>
      <el-divider />
      <div v-for="i in 10">
        <span v-if="i % 2 === 0">
          <el-skeleton-item style="width:20%" /> <el-skeleton-item class="ml-20" style="width:10%" />
        </span>
        <span v-else>
          <el-skeleton-item style="width:10%" /> <el-skeleton-item class="ml-20" style="width:20%" />
        </span>
      </div>
    </template>
     <template>
       <div v-if="data != null">
         <div class="flex gaps auto">
           <el-image
            :src="defaultImage"
            fit="contain"
            style="width: 200px; height: 200px;"
            class="imageSlot p-10 card-shadow--small">
             <div slot="error" class="imageSlot">
               <i class="el-icon-picture-outline"></i>
             </div>
           </el-image>
           <span>
             <span class="fs-14">
               {{$t('products.details.technicalSheet.reference')}}
               {{reference}}
             </span>
             <span class="fs-14">
               <br>
               {{$t('products.details.technicalSheet.webSite')}}
               <span v-if="webSite != null">
                 <el-link  :href="websiteUrl" target="_blank">
                   {{webSite}} <i class="mdi mdi-launch ml-10"></i>
                 </el-link>
               </span>
               <span v-else> -- </span>
             </span>
           </span>
          </div>
         <el-divider/>
         <div class="right-box box grow">
           <dl class="horizontal">
             <technicalSheetLine :data="prop" v-for="prop in properties" :key="prop.id"/>
           </dl>
         </div>
       </div>
       <div v-else class="m-20 flex gaps auto">
         <span class="fs-14" style="text-align:center">Aucune fiche technique disponible</span>
       </div>

     </template>
  </el-skeleton>

</template>
<script>
import technicalSheetLine from './technical-sheet-line';
import productItemApi from '@/services/API/productItem'
export default {
  name: 'technical-sheet-view',
	props: {
    id: {
      type: Number,
      default : null
    },
    image : {
      type: String,
      default : null,
    }
	},
  data() {
    return {
      data : null,
      technicalSheetLoading: false,
    };
  },
  components: {
    technicalSheetLine,
  },
  watch : {
    id : function(val){
      if (val != null) {
        this.fetchProductItem(val);
      } else {
        this.data = null;
      }

    }
  },
	methods: {
    fetchProductItem (productItemId) {
      this.technicalSheetLoading = true;
      return productItemApi.getProductItem(productItemId)
        .then((productItem => {
          this.data = productItem;
          this.technicalSheetLoading = false;
        }))
        .catch((err) => {
          this.$message.error('Une erreur est survenue, veuillez réessayer plus tard');
          this.technicalSheetLoading = false;
          console.log(err);
        })
    },
  },
	computed: {
    defaultImage () {
      const technicalSheetImage = _.get(this.data, 'image.thumbnailLink');
      if (technicalSheetImage != null) return technicalSheetImage;
      return this.image;
    },
    properties () {
      return _.get(this.data, 'properties');
    },
    websiteUrl () {
      const webSite = this.webSite;
      if (!_.startsWith(webSite, 'http')) {
        return `http://${webSite}`;
      }
      return webSite;
    },
    reference () {
      return _.get(this.data, 'releaseYear');
    },
    webSite () {
      const webSite =  _.trim(_.get(this.data, 'webSite'));
      return webSite != '' ? webSite : null;
    }
	},
  mounted () {
    if (this.id != null) {
      this.fetchProductItem(this.id);
    }
  },
}
</script>
<style lang="scss" scoped>

  .imageSlot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 30px;
  }

  dl {
    margin: 0px;
  }


</style>
